import script from "./file.vue?vue&type=script&setup=true&lang=ts"
export * from "./file.vue?vue&type=script&setup=true&lang=ts"

import "./file.vue?vue&type=style&index=0&id=56f09929&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f09929"]])

export default __exports__